import styled from 'styled-components';
import MobileBlockSvg from '../../assets/onboarding/server-error.svg';

const MobileBlockIcon = styled(MobileBlockSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => '20rem'};
height: ${props => '20rem'};
display: flex;
`;

export default MobileBlockIcon;
